<template>
    <div>
        <h5 class="heading-1 mb-4 text-primary">
            <span>Dotações Orçamentárias</span>
        </h5>
        <app-tabela
            :itens="dotacoes"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :mostrarFiltro="false"
            :bordered="false"
            :small="false"
        >
            <template slot="unidade" slot-scope="data"
                >({{ data.codUnidade }}) {{ data.unidade }}</template
            >
            <template slot="projeto" slot-scope="data"
                >({{ data.codProjeto }}) {{ data.projeto }}</template
            >
            <template slot="acao" slot-scope="data"
                >({{ data.codAcao }}) {{ data.acao }}</template
            >
            <template slot="jan" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 1) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 1) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 1) | currency
                    }}</strong></span
                ></template
            >
            <template slot="fev" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 2) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 2) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 2) | currency
                    }}</strong></span
                ></template
            >
            <template slot="mar" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 3) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 3) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 3) | currency
                    }}</strong></span
                ></template
            >
            <template slot="abr" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 4) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 4) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 4) | currency
                    }}</strong></span
                ></template
            >
            <template slot="mai" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 5) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 5) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 5) | currency
                    }}</strong></span
                ></template
            >
            <template slot="jun" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 6) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 6) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 6) | currency
                    }}</strong></span
                ></template
            >
            <template slot="jul" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 7) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 7) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 7) | currency
                    }}</strong></span
                ></template
            >
            <template slot="ago" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 8) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 8) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 8) | currency
                    }}</strong></span
                ></template
            >
            <template slot="set" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 9) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 9) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 9) | currency
                    }}</strong></span
                ></template
            >
            <template slot="out" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 10) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 10) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 10) | currency
                    }}</strong></span
                ></template
            >
            <template slot="nov" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 11) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 11) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 11) | currency
                    }}</strong></span
                ></template
            >
            <template slot="dez" slot-scope="data"
                ><span v-if="obterValorPorMes(data, 12) == 0">{{
                    0 | currency
                }}</span
                ><span v-if="obterValorPorMes(data, 12) > 0"
                    ><strong>{{
                        obterValorPorMes(data, 12) | currency
                    }}</strong></span
                ></template
            >
        </app-tabela>
    </div>
</template>

<script>
export default {
    props: {
        dotacoes: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'jan',
                    label: 'JAN',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'fev',
                    label: 'FEV',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'mar',
                    label: 'MAR',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'abr',
                    label: 'ABR',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'mai',
                    label: 'MAI',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'jun',
                    label: 'JUN',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'jul',
                    label: 'JUL',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'ago',
                    label: 'AGO',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'set',
                    label: 'SET',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'out',
                    label: 'OUT',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'nov',
                    label: 'NOV',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dez',
                    label: 'DEZ',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterValorPorMes(dotacao, mes) {
            return dotacao.meses.find(e => e.mes == mes).valor
        }
    },

    computed: {},

    created() {},

    watch: {},

    components: {}
}
</script>
